"use client";

import { authClient } from "lib/auth/client";
import { UserRole } from "../types/user";

export const useUserRole = () => {
  const { data: session } = authClient.useSession();

  const userRole = (session?.user as any)?.role as UserRole | undefined;

  const hasRole = (requiredRole: UserRole): boolean => {
    if (!userRole) return false;

    const roleHierarchy = {
      [UserRole.USER]: 0,
      [UserRole.MODERATOR]: 1,
      [UserRole.ADMIN]: 2,
    };

    return roleHierarchy[userRole] >= roleHierarchy[requiredRole];
  };

  const isAdmin = () => hasRole(UserRole.ADMIN);
  const isModerator = () => hasRole(UserRole.MODERATOR);
  const isUser = () => userRole === UserRole.USER;

  return {
    userRole,
    hasRole,
    isAdmin,
    isModerator,
    isUser,
  };
};
